var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepaymentDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "81px",
    height: "80px",
    viewBox: "0 0 81 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 23 Copy 3@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4.24400098e-13%",
    y1: "1.2204647e-12%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C8F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D41E1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Barlow-Marshall---Home-V2",
    transform: "translate(-542.000000, -964.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Companies-Box-Copy-2",
    transform: "translate(0.000000, 836.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19-Copy-2",
    transform: "translate(479.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23-Copy-3",
    transform: "translate(63.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Polygon-Copy-16",
    fill: "url(#linearGradient-1)",
    points: "40 0 74.6410162 20 74.6410162 60 40 80 5.35898385 60 5.35898385 20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-date-3535610",
    transform: "translate(22.000000, 24.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6796615,2.55359577 L28.0165123,2.55359577 L28.0165123,0 L26.5715122,0 L26.5715122,2.55359577 L8.4290103,2.55359577 L8.4290103,0 L6.98401019,0 L6.98401019,2.55359577 L2.32086096,2.55359577 C1.70646435,2.5498908 1.11615597,2.78986175 0.680336657,3.22049284 C0.244840281,3.65112394 1.00357283e-06,4.23653212 1.00357283e-06,4.84727927 L1.00357283e-06,29.6952253 C-0.000571350808,30.307118 0.24369532,30.8939562 0.679191696,31.3262434 C1.11468807,31.7588736 1.70525333,32.0011223 2.32081692,31.9999882 L32.6791771,31.9999882 C33.2947187,32.0011241 33.88535,31.7588736 34.3208023,31.3262434 C34.7562987,30.8938978 35.0005645,30.3070669 35.000001,29.6952253 L35.000001,4.84727927 C35.000001,4.23652483 34.7551538,3.65110205 34.3196574,3.22049284 C33.8838748,2.78986175 33.2935957,2.54988941 32.6791331,2.55359577 L32.6796615,2.55359577 Z M2.32130133,3.99002987 L6.98445056,3.99002987 L6.98445056,6.22442618 L8.42945067,6.22442618 L8.42945067,3.99002987 L26.5719526,3.99002987 L26.5719526,6.22442618 L28.0169527,6.22442618 L28.0169527,3.99002987 L32.6801019,3.99002987 C32.9114648,3.98603984 33.1345195,4.07467793 33.2993719,4.23570038 C33.4639381,4.39700738 33.5565405,4.61760157 33.5559707,4.84730846 L33.5559707,9.33660278 L1.44566737,9.33660278 L1.44566737,4.84730846 C1.44509665,4.61760157 1.53769996,4.39700738 1.70226616,4.23570038 C1.86711859,4.07467793 2.09017324,3.98603897 2.32153619,3.99002987 L2.32130133,3.99002987 Z M32.6796615,30.5635009 L2.32130133,30.5635009 C2.08878607,30.5651871 1.86545253,30.474269 1.70088633,30.3109702 C1.53632014,30.1479487 1.44429019,29.9262236 1.44542459,29.6950867 L1.44542459,10.772942 L33.5557438,10.772942 L33.5557438,29.6950867 C33.55688,29.9262236 33.4648482,30.1479487 33.300282,30.3109702 C33.1357158,30.4742763 32.9123749,30.5651916 32.679867,30.5635009 L32.6796615,30.5635009 Z",
    id: "Shape"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepaymentDate);
export default __webpack_public_path__ + "static/media/repayment-date.ee5ac4f2f7a19cecddfbd4a42abd4f94.svg";
export { ForwardRef as ReactComponent };